<template>
    <div class="feedback-container"
    :style="{
        'background':`linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`
    }" >    
        <div class="feedback" v-if="!showInfo">
             <header-feedback :index="index" :steps="4"></header-feedback>
            <div class="container">
                <router-view :index="index"></router-view>
            </div>
            <!-- <footer-default></footer-default> -->
        </div>
       
        <info-default 
            v-if="showInfo"
            imageUrl="feedback-icon.png"
            :smallTitle="smallTitle"
            :title="title"
            :descInfo="desc"
            actionName="goFeedback"
            :textButton='$t("containers.FeedbackContainer.textButton")'><Icon /></info-default>
    </div>
</template>
<script>
import Bus from '../main.js'
import InfoDefault from '../components/Shared/InfoDefault.vue'
import HeaderFeedback from '../components/feedback/HeaderFeedback.vue'
import FooterDefault from '../components/Shared/FooterDefault.vue'
import Icon from '../components/Shared/CustomIcons/Feedback/feedback'
export default {
    components:{
        InfoDefault,
        HeaderFeedback,
        FooterDefault,
        Icon
    },
    data(){
        return{
            smallTitle : this.$t("containers.FeedbackContainer.smallTitle"),
            title : this.$t("containers.FeedbackContainer.title"),
            desc : this.$t("containers.FeedbackContainer.desc"),
            index : 1, 
            showInfo : true,
            colors: {}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        Bus.$on('goFeedback', this.goFeedback)
        Bus.$on('nextStep', this.nextStep)
        let routeName = this.$route.name
        routeName == 'Feedback' ? this.showInfo = true : this.showInfo = false
        
        if(routeName != 'Feedback' && this.index == 0){
            this.$router.push('/feedback')
            this.showInfo = true
        }
    },
    destroyed(){
        Bus.$off('goFeedback')
        Bus.$off('nextStep')
    },
    methods: {
        async goFeedback(){
            await this.$router.push('/feedback-experience')
            this.showInfo = false
        },
        nextStep(){
            this.index = this.index + 1
        }
    }
}
</script>
<style lang="scss" scoped>
    .feedback-container{
        width: 100%;
        height: 100vh;
        .feedback{
            height: auto;
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .container{
            height: 650px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            padding: 0;
        }
    }

    @media only screen and (min-width: 750px){
        .feedback-container{
            height: 650px;
            overflow-y: scroll;

            .feedback{
                // height: 920px;

                .container{
                    align-items: flex-start;
                }
            }
        }
    }
</style>

